(function () {
  try {
    /* main variables */
    var debug = 0;
    var variation_name = "cre-t-1";

    /* all Pure helper functions */

    function waitForElement(selector, trigger, delayInterval = 50, delayTimeout = 15000) {
      var interval = setInterval(function () {
        if (document && document.querySelector(selector) && document.querySelectorAll(selector).length > 0) {
          clearInterval(interval);
          trigger();
        }
      }, delayInterval);
      setTimeout(function () {
        clearInterval(interval);
      }, delayTimeout);
    }

    function forceInsertion(trigger, delayInterval = 50, delayTimeout = 15000) {
      var interval = setInterval(function () {
        trigger();
      }, delayInterval);
      setTimeout(function () {
        clearInterval(interval);
      }, delayTimeout);
    }

    /**
     * Adds a CSS class to an element
     * @param {string|HTMLElement} selector - CSS selector string or DOM element
     * @param {string} className - The class name to add (without dot)
     *
     * Usage Examples:
     * addClass(".button", "active");
     * addClass(document.getElementById("btn"), "active");
     */
    function addClass(selector, className) {
      var element = typeof selector === "string" ? document.querySelector(selector) : selector;
      if (!element) return;
      if (element.classList) element.classList.add(className);
      else if (!element.className.match(new RegExp("\b" + className + "\b"))) {
        element.className += " " + className;
      }
    }

    /**
     * Removes a CSS class from an element
     * @param {string|HTMLElement} selector - CSS selector string or DOM element
     * @param {string} className - The class name to remove (without dot)
     *
     * Usage Examples:
     * removeClass(".button", "active");
     * removeClass(document.getElementById("btn"), "active");
     */
    function removeClass(selector, className) {
      var element = typeof selector === "string" ? document.querySelector(selector) : selector;
      if (!element) return;
      if (element.classList) element.classList.remove(className);
      else element.className = element.className.replace(new RegExp("\b" + className + "\b", "g"), "");
    }

    var heroSectionHTML = `
      <div class="cre-t-1-left">
        <h2 class="cre-t-1-header">
          <strong>Pure Raw Honey, Straight from the Source</strong>
        </h2>
        <p class="cre-t-1-des cre-t-1-des1">
          <strong>Unheated, unpasteurised, antibacterial, and bursting with natural flavour. Produced by the bees of small scale artisan beekeepers.</strong>
        </p>
        <p class="cre-t-1-des cre-t-1-des2">
          We travel to remote mountains and wild forests across Europe to find small-scale, artisan beekeepers whose honey meets our exacting standards. No middlemen. No factory farming. No compromises.
          <br />
          <br />
          Every jar we sell is:
        </p>
        <ul class="cre-t-1-points">
          <li class="cre-t-1-point cre-t-1-point1"><strong>Raw & unheated</strong> — coarse-filtered only, so all the natural enzymes, flavour, and beneficial properties are preserved</li>
          <li class="cre-t-1-point cre-t-1-point2"><strong>From pesticide-free landscapes</strong> — sourced from remote mountains and wild forests far from conventional agriculture.</li>
          <li class="cre-t-1-point cre-t-1-point3"><strong>Made by real beekeepers</strong> — people like Antonio, who tends his hives in the Sierra del Rincón Biosphere Reserve in Spain</li>
          <li class="cre-t-1-point cre-t-1-point4"><strong>Certified organic</strong> or produced to organic principles — you can <a href="https://www.therawhoneyshop.com/pages/our-organic-certificate" target="_blank">view our organic certificate here</a></li>
        </ul>

        <div class="cre-t-1-cta">
          <a href="https://www.therawhoneyshop.com/collections/all">
            <span>
              <span>SHOP OUR HONEYS</span>
              <span>SHOP OUR HONEYS</span>
            </span>
          </a>
        </div>
        <div class="cre-t-1-review-wrapper">
          <div class="cre-t-1-review-img">
            <a href="https://www.therawhoneyshop.com/a/review/all"><img src="https://www.therawhoneyshop.com/cdn/shop/files/review_150x.svg?v=1730900481" /></a>
          </div>
          <div class="cre-t-1-review-texts">
            <div class="cre-t-1-review-text1">
              <p class="cre-t-1-review-text-content1"><em>"We are really pleased with the friendly informative help we have received and the speedy arrival of our order. The honey (3 Varieties) are delicious - amazingly better than honeys we have previously bought locally."</em></p>
              <p class="cre-t-1-review-text-content2">M Whealy, Brentwood</p>
            </div>
            <div class="cre-t-1-review-text2">
              <p class="cre-t-1-review-text-content1"><em>"I have been looking for a long time to find a place where I can trust good honey. Finally I have. Honest, genuine, and a fast service. Thank you guys, will be promoting you to all my contacts!"</em></p>
              <p class="cre-t-1-review-text-content2">Yaseen, London</p>
            </div>
          </div>
        </div>
      </div>

      <div class="cre-t-1-right">
        <div class="cre-t-1-img-with-text cre-t-1-img-with-text1">
          <img src="//www.therawhoneyshop.com/cdn/shop/files/Antonio_dc6503ae-c194-41f6-b61d-e656a1c7b485.png?v=1741186390" />
          <h3>Antonio Simon, 4th generation beekeeper. Certified organic.</h3>
        </div>
        <div class="cre-t-1-img-with-text cre-t-1-img-with-text2">
          <img src="//www.therawhoneyshop.com/cdn/shop/files/PHOTO-2022-06-02-10-30-02_1.jpg?v=1740847989" />
          <h3>The beekeepers at Antonio's hives</h3>
        </div>
      </div>
    `;

    function insertHtml() {
      var element = document.querySelector('html[lang="en"] section.shopify-section.custom-video.desktop-only .video-section .vid_cov');

      if (!document.querySelector(".cre-t-1-container")) {
        element && element.insertAdjacentHTML("beforeend", heroSectionHTML);
      }
    }

    function addingClass() {
      forceInsertion(
        function () {
          var element1 = document.querySelectorAll('html[lang="en"] section.shopify-section.section-image-with-text section.image-with-text');
          if (element1.length > 0) {
            element1.forEach(function (item) {
              var parent = item.closest("section.shopify-section.section-image-with-text");
              if (parent) {
                parent.classList.add("cre-t-1-hero-mobile");
              }
            });
          }

          //  section.shopify-section.custom-video:not(.desktop-only)  .video-section .vid_cov
          var element3 = document.querySelector("section.shopify-section.custom-video:not(.desktop-only) .video-section .vid_cov");
          if (element3) {
            var parent = element3.closest("section.shopify-section");
            if (parent) {
              parent.classList.add("cre-t-1-hero-mobile");
            }
          }
        },
        100,
        3000,
      );
    }

    /* Variation functions */

    /* Variation Init */
    function init() {
      if (document.body.classList.contains(variation_name)) return;
      document.body.classList.add(variation_name);

      waitForElement('html[lang="en"] section.shopify-section.custom-video.desktop-only .video-section .vid_cov', insertHtml);
      addingClass();
    }

    /* Initialise variation */
    waitForElement('html[lang="en"] #MainContent section', init);
  } catch (e) {
    if (debug) console.log(e, "error in Test " + variation_name);
  }
})();
